<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs" :form-fields="formFields"
                  :permission="permission"/>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable.vue";

export default {
  name: 'TingWuVideoTask',
  components: {CommonTable},
  data() {
    return {
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }],
      permission: {
        add: 'tingWuVideoTask:add',
        update: 'tingWuVideoTask:update',
        delete: 'tingWuVideoTask:delete',
        deleteBatch: 'tingWuVideoTask:deleteBatch'
      },
      url: {
        get: '/tingWuVideoTask/listByCondition',
        add: '/tingWuVideoTask/add',
        update: '/tingWuVideoTask/update',
        delete: '/tingWuVideoTask/delete',
        delete_batch: '/tingWuVideoTask/deleteBatch',
        status: '/tingWuVideoTask/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      },
        {
          field: 'agentId',
          label: '代理',
          selectUrl: '/agent/getAll',
          selectData: [],
          show: {
            type: 'select'
          },
          width: '',
        }, {
          field: 'phone',  // 字段名
          label: '用户',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'videoUrl',  // 字段名
          label: '视频路径',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'taskId',  // 字段名
          label: 'taskId',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'transcriptionUrl',  // 字段名
          label: '转录URL',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'meetingAssistance',  // 字段名
          label: '智能纪要URL',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'autoChapters',  // 字段名
          label: '章节预览',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'summarization',  // 字段名
          label: '摘要',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'videoParsedText',  // 字段名
          label: '解析文案',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'status',  // 字段名
          label: '状态',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'message',  // 字段名
          label: '日志',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        },
        {
          field: 'createTime',
          label: '时间',
          show: true,
          width: '',
        }

      ],
      formFields: {
        addTitle: '添加',
        updateTitle: '修改',
        model: [
          {
            field: 'id',  // 字段名
            label: 'ID',  // 字段显示名称
            type: 'input',
            add: false,  // 是否添加
            update: true
          },
          {
            field: 'agentId',  // 字段名
            label: 'agentId',  // 字段显示名称
            type: 'input',
            placeholder: '请输入agentId',
            rules: [
              {required: true, message: 'agentId不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'userId',  // 字段名
            label: 'userId',  // 字段显示名称
            type: 'input',
            placeholder: '请输入userId',
            rules: [
              {required: true, message: 'userId不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'videoUrl',  // 字段名
            label: 'videoUrl',  // 字段显示名称
            type: 'input',
            placeholder: '请输入videoUrl',
            rules: [
              {required: true, message: 'videoUrl不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'taskId',  // 字段名
            label: 'taskId',  // 字段显示名称
            type: 'input',
            placeholder: '请输入taskId',
            rules: [
              {required: true, message: 'taskId不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'transcriptionUrl',  // 字段名
            label: 'transcriptionUrl',  // 字段显示名称
            type: 'input',
            placeholder: '请输入transcriptionUrl',
            rules: [
              {required: true, message: 'transcriptionUrl不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'meetingAssistance',  // 字段名
            label: 'meetingAssistance',  // 字段显示名称
            type: 'input',
            placeholder: '请输入meetingAssistance',
            rules: [
              {required: true, message: 'meetingAssistance不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'autoChapters',  // 字段名
            label: 'autoChapters',  // 字段显示名称
            type: 'input',
            placeholder: '请输入autoChapters',
            rules: [
              {required: true, message: 'autoChapters不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'summarization',  // 字段名
            label: 'summarization',  // 字段显示名称
            type: 'input',
            placeholder: '请输入summarization',
            rules: [
              {required: true, message: 'summarization不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'videoParsedText',  // 字段名
            label: 'videoParsedText',  // 字段显示名称
            type: 'input',
            placeholder: '请输入videoParsedText',
            rules: [
              {required: true, message: 'videoParsedText不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'status',  // 字段名
            label: 'status',  // 字段显示名称
            type: 'input',
            placeholder: '请输入status',
            rules: [
              {required: true, message: 'status不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'message',  // 字段名
            label: 'message',  // 字段显示名称
            type: 'input',
            placeholder: '请输入message',
            rules: [
              {required: true, message: 'message不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          },
        ]
      },
      operate: []
    }
  }
}
</script>

<style scoped>

</style>
